<template>
  <el-card class="item_content">
    <div slot="header" class="content_header">
      <span class="content_header_title">{{ title }}</span>
    </div>
    <div class="content_main">
      <slot></slot>
    </div>
    <p class="show_more">
      <router-link :to="morePath">
        <span class="test_title">查看更多&gt;</span>
      </router-link>
    </p>
  </el-card>
</template>
<script>
export default {
  props: {
    title: String,
    morePath: {
      type: String,
      required: true
    }
  },
  data() {
    return {}
  }
}
</script>
<style scoped lang="less">

::v-deep.item_content {
  padding: 0 16px;

  .el-card__header {
    padding: 0px;
    text-align: center;
  }

  .el-card__body {
    padding: 0;
  }

  .content_header {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #e5e5e5;

    .content_header_title {
      display: inline-block;
      padding: 0 10px;
      height: 40px;
      color: #b93229;
      font-weight: 800;
      font-size: 20px;
      border-bottom: 2px solid #b93229;
    }
  }

  .content_main {
    margin-top: 16px;
    height: 450px;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

  .show_more {
    height: 40px;
    line-height: 40px;
    text-align: center;

    .test_title {
      font-size: 14px;
      color: #b93229;
    }
  }
}


</style>
